type FormType = {
  fill: string
  width: string
  height: string
  title: string
}

function Form(props: FormType) {
  const fill = props.fill || 'currentColor'
  const width = props.width || '1em'
  const height = props.height || '1em'
  const title = props.title || 'form'

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 22 23'
      fill='none'
    >
      <title>{title}</title>
      <path
        d='M7.14551 22.0423H1.39551V0.958984H18.6455V8.14648'
        stroke={fill}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
      <path
        d='M13.3747 20.6048L10.0205 21.5632L10.9788 18.209L18.1663 11.0215L20.5622 13.4173L13.3747 20.6048Z'
        stroke={fill}
        strokeWidth='1.5'
        strokeMiterlimit='10'
        strokeLinecap='square'
      />
    </svg>
  )
}

export default Form
